import {
    SET_TABLE_FILTER_CACHE,
    CLEAR_TABLE_FILTER_CACHE,
    CLEAR_ALL_TABLE_FILTER_CACHE
  } from './tableFilter.constants';
  
  const initialState = {};
  
  export default function tableFilterReducer(state = initialState, action) {
    switch (action.type) {
      case SET_TABLE_FILTER_CACHE:
        return {
          ...state,
          [action.payload.route]: action.payload.filters
        };
  
      case CLEAR_TABLE_FILTER_CACHE:
        const newState = { ...state };
        delete newState[action.payload.route];
        return newState;

      case CLEAR_ALL_TABLE_FILTER_CACHE:
        return {};
  
      default:
        return state;
    }
  }
  